(function () {

  let syncTimer   = null;
  let initialized = false;
  let appliedDiscountCode = '';
  let appliedDiscountLabel = '';
  let autoApplyInFlight = false;
  let lastAutoApplyKey = '';

  const discountDetails = {};

  try {
    localStorage.removeItem('crb_removed_discount_code');
  } catch(e) {}

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(doSync, 10);
  }

  function getProgressTotal(cart) {
    const excludedKeys = new Set(
      [...document.querySelectorAll('#CartDrawer [data-crb-include-shipping="true"][data-cart-item-key]')]
        .map(el => el.dataset.cartItemKey)
    );

    return (cart.items || []).reduce((total, item) => {
      return total + (excludedKeys.has(item.key) ? 0 : (item.final_line_price || 0));
    }, 0);
  }

  function injectBar() {
    const header = document.querySelector('#CartDrawer .drawer__header');
    if (!header) return;

    const cfg = window.crbConfig;
    if (!cfg || !cfg.tiers || !cfg.tiers.length) return;

    const nextEl = header.nextElementSibling;
    if (nextEl && nextEl.id === 'crb-placeholder' && document.getElementById('cart-rewards-bar')) return;

    const old = document.getElementById('crb-placeholder');
    if (old) old.remove();

    const placeholder = document.createElement('div');
    placeholder.id = 'crb-placeholder';
    placeholder.style.cssText = 'flex-shrink:0;display:block;width:100%;';
    header.insertAdjacentElement('afterend', placeholder);

    const bar = document.createElement('div');
    bar.id        = 'cart-rewards-bar';
    bar.className = 'cart-rewards-bar';
    bar.innerHTML = `
      <div class="crb-message" id="crb-message">&nbsp;</div>
      <div class="crb-progress-wrap">
        <div class="crb-bar">
          <div class="crb-fill" id="crb-fill"></div>
        </div>
        <div class="crb-tiers" id="crb-tiers">
          ${cfg.tiers.map(t => `
            <div class="crb-tier" id="crb-tier-${t.id}"
                 style="left:${t.pct}%"
                 data-threshold="${t.threshold}"
                 data-type="${t.type}"
                 data-gift="${t.gift}"
                 data-code="${t.code}"
                 data-label="${t.label}"
                 data-msg-p="${t.msgP}"
                 data-msg-a="${t.msgA}">
              <span class="crb-tier-dot">${t.icon}</span>
              <span class="crb-tier-label">${t.label}</span>
            </div>
          `).join('')}
        </div>
      </div>
      <div id="crb-discount-slot"></div>
    `;
    placeholder.appendChild(bar);
  }

  /* ── 用 Dawn 的 Section Rendering 重新渲染購物車並重新插入進度條 ── */
  function reRenderCart() {
    return fetch('/cart?section_id=cart-drawer')
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newContent = doc.querySelector('#CartDrawer');
        if (newContent) {
          document.querySelector('#CartDrawer').innerHTML = newContent.innerHTML;
        }
        // Section Rendering 後重新插入進度條
        setTimeout(() => { injectBar(); scheduleSync(); }, 50);
      })
      .catch(e => console.warn('[CRB] reRender:', e));
  }

  function cartAjaxUrl(path) {
    const root = window.Shopify?.routes?.root || '/';
    return root + path.replace(/^\//, '');
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));
  }

  function getCookie(name) {
    const escapedName = name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&');
    const match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function deleteCookie(name) {
    const expires = 'expires=Thu, 01 Jan 1970 00:00:00 GMT';
    document.cookie = `${name}=; ${expires}; path=/`;
    document.cookie = `${name}=; ${expires}; path=/; domain=${window.location.hostname}`;

    const parts = window.location.hostname.split('.');
    if (parts.length > 2) {
      document.cookie = `${name}=; ${expires}; path=/; domain=.${parts.slice(-2).join('.')}`;
    }
  }

  function clearDiscountCookies() {
    ['discount_code', 'discount', '_shopify_discount'].forEach(deleteCookie);
  }

  function removeDiscountParamsFromUrl() {
    if (!window.history?.replaceState) return;

    const url = new URL(window.location.href);
    ['discount_code', 'discount', 'code', 'discount_label', 'discount_description', 'discount_text', 'discount_min', 'discount_min_amount', 'discount_threshold'].forEach(param => {
      url.searchParams.delete(param);
    });

    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  function cleanDiscountCode(code) {
    try {
      return decodeURIComponent(String(code || '')).trim();
    } catch(e) {
      return String(code || '').trim();
    }
  }

  function sameCode(a, b) {
    return cleanDiscountCode(a).toLowerCase() === cleanDiscountCode(b).toLowerCase();
  }

  function formatMoney(cents) {
    return 'NT$' + Math.round((Number(cents) || 0) / 100).toLocaleString('zh-TW');
  }

  function isFreeShippingDetail(detail) {
    return /免運|free\s*shipping/i.test(String(detail?.label || ''));
  }

  function readDiscountCodeFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const paramCode = params.get('discount_code') || params.get('discount') || params.get('code');
    if (paramCode) return cleanDiscountCode(paramCode);

    const redirect = params.get('redirect');
    if (redirect) {
      try {
        const redirectUrl = new URL(redirect, window.location.origin);
        const redirectCode = redirectUrl.searchParams.get('discount_code') || redirectUrl.searchParams.get('discount') || redirectUrl.searchParams.get('code');
        if (redirectCode) return cleanDiscountCode(redirectCode);
      } catch(e) {}
    }

    const pathMatch = window.location.pathname.match(/\/discount\/([^/?#]+)/i);
    return pathMatch ? cleanDiscountCode(pathMatch[1]) : '';
  }

  function readDiscountCodeFromCookie() {
    return cleanDiscountCode(
      getCookie('discount_code') ||
      getCookie('discount') ||
      getCookie('_shopify_discount')
    );
  }

  function readDiscountLabelFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return cleanDiscountCode(
      params.get('discount_label') ||
      params.get('discount_description') ||
      params.get('discount_text')
    );
  }

  function readDiscountMinFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const value = cleanDiscountCode(
      params.get('discount_min') ||
      params.get('discount_min_amount') ||
      params.get('discount_threshold')
    );
    const amount = Number(value);
    return Number.isFinite(amount) && amount > 0 ? Math.round(amount * 100) : 0;
  }

  function getDiscountDetail(code) {
    const cleanCode = cleanDiscountCode(code);
    if (!cleanCode) return null;

    const newsletter = window.crbConfig?.newsletterDiscount;
    if (newsletter?.enabled && newsletter.code && sameCode(newsletter.code, cleanCode)) {
      return {
        code: cleanCode,
        label: cleanDiscountCode(newsletter.label || ''),
        minSubtotal: Math.max(0, parseInt(newsletter.minSubtotal, 10) || 0)
      };
    }

    const manual = discountDetails[cleanCode] || discountDetails[cleanCode.toUpperCase()] || discountDetails[cleanCode.toLowerCase()];
    if (typeof manual === 'string') {
      return { code: cleanCode, label: manual, minSubtotal: 0 };
    }
    if (manual && typeof manual === 'object') {
      return {
        code: cleanCode,
        label: cleanDiscountCode(manual.label || ''),
        minSubtotal: Math.max(0, parseInt(manual.minSubtotal, 10) || 0)
      };
    }

    return {
      code: cleanCode,
      label: readDiscountLabelFromUrl(),
      minSubtotal: readDiscountMinFromUrl()
    };
  }

  function captureAppliedDiscountCode() {
    const storageKey = 'crb_applied_discount_code';
    const removedKey = 'crb_removed_discount_code';
    const urlCode = readDiscountCodeFromUrl();
    const code = urlCode || readDiscountCodeFromCookie();
    let removedCode = '';

    try { removedCode = sessionStorage.getItem(removedKey) || ''; } catch(e) {}

    if (code) {
      if (!urlCode && removedCode && removedCode.toLowerCase() === code.toLowerCase()) {
        return '';
      }
      try {
        localStorage.setItem(storageKey, code);
        if (urlCode) sessionStorage.removeItem(removedKey);
      } catch(e) {}
      return code;
    }

    try {
      return localStorage.getItem(storageKey) || '';
    } catch(e) {
      return '';
    }
  }

  function captureAppliedDiscountLabel(code) {
    const storageKey = 'crb_applied_discount_label';
    const storageCodeKey = 'crb_applied_discount_label_code';
    const detail = getDiscountDetail(code);
    const label = readDiscountLabelFromUrl() || detail?.label || '';

    if (label) {
      try {
        localStorage.setItem(storageKey, label);
        localStorage.setItem(storageCodeKey, cleanDiscountCode(code));
      } catch(e) {}
      return label;
    }

    try {
      const storedCode = localStorage.getItem(storageCodeKey) || '';
      if (!sameCode(storedCode, code)) return '';
      return localStorage.getItem(storageKey) || '';
    } catch(e) {
      return '';
    }
  }

  function rememberDiscount(code) {
    const detail = getDiscountDetail(code);

    try {
      localStorage.setItem('crb_applied_discount_code', code);
      sessionStorage.removeItem('crb_removed_discount_code');
      const label = detail?.label || '';
      if (label) {
        localStorage.setItem('crb_applied_discount_label', label);
        localStorage.setItem('crb_applied_discount_label_code', cleanDiscountCode(code));
      } else {
        localStorage.removeItem('crb_applied_discount_label');
        localStorage.removeItem('crb_applied_discount_label_code');
      }
    } catch(e) {}

    appliedDiscountCode = code;
    appliedDiscountLabel = captureAppliedDiscountLabel(code);
  }

  function forgetDiscount() {
    const removedCode = appliedDiscountCode || readDiscountCodeFromUrl() || readDiscountCodeFromCookie();

    try {
      localStorage.removeItem('crb_applied_discount_code');
      localStorage.removeItem('crb_applied_discount_label');
      localStorage.removeItem('crb_applied_discount_label_code');
      if (removedCode) sessionStorage.setItem('crb_removed_discount_code', removedCode);
    } catch(e) {}

    clearDiscountCookies();
    removeDiscountParamsFromUrl();
    appliedDiscountCode = '';
    appliedDiscountLabel = '';
    lastAutoApplyKey = '';
  }

  function updateCartDiscount(code) {
    return fetch(cartAjaxUrl('/cart/update.js'), {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ discount: code })
    })
      .then(r => r.json())
      .then(cart => {
        if (code) {
          rememberDiscount(code);
        } else {
          forgetDiscount();
        }
        updateBar(cart);
        return reRenderCart();
      });
  }

  function ensureDiscountApplied(code, total) {
    const detail = getDiscountDetail(code);
    if (!detail?.minSubtotal || total < detail.minSubtotal) return;
    if (autoApplyInFlight) return;

    const key = `${cleanDiscountCode(code).toLowerCase()}:${total}`;
    if (lastAutoApplyKey === key) return;

    autoApplyInFlight = true;
    lastAutoApplyKey = key;
    updateCartDiscount(code)
      .catch(e => console.warn('[CRB] discount auto apply:', e))
      .finally(() => { autoApplyInFlight = false; });
  }

  function discountBannerHTML(code, labelHTML, detail, canRemove, canCopy = true) {
    const safeCode = escapeHTML(code);
    const safeDetail = escapeHTML(detail);
    return `
      <div class="crb-discount-banner">
        <span>
          ${labelHTML} <span class="crb-applied-code">${safeCode}</span>
          ${safeDetail ? `<span class="crb-discount-detail" style="display:block;margin-top:2px;font-size:11px;line-height:1.4;opacity:.78;">${safeDetail}</span>` : ''}
        </span>
        <span style="display:flex;align-items:center;gap:6px;flex-shrink:0;">
          ${canCopy ? `<button class="crb-code-btn" data-code="${safeCode}">${safeCode}&nbsp;複製</button>` : ''}
          ${canRemove ? '<button class="crb-code-btn crb-remove-code-btn" type="button" data-crb-remove-code style="background:#6b7280;">移除</button>' : ''}
        </span>
      </div>`;
  }

  function discountFormHTML() {
    return `
      <form class="crb-discount-form" data-crb-discount-form style="display:flex;gap:8px;margin-top:10px;">
        <input
          class="crb-discount-input"
          name="discount"
          type="text"
          autocomplete="off"
          placeholder="輸入優惠碼"
          style="min-width:0;flex:1;border:1px solid rgba(0,0,0,.16);border-radius:6px;padding:7px 9px;font:inherit;font-size:12px;"
        >
        <button class="crb-code-btn" type="submit">套用</button>
      </form>
      <div class="crb-discount-form-message" data-crb-discount-message style="display:none;margin-top:6px;font-size:11px;line-height:1.4;color:#166534;"></div>`;
  }

  function bindDiscountCopyButtons(slot) {
    slot.querySelectorAll('.crb-code-btn').forEach(btn => {
      if (btn.hasAttribute('data-crb-remove-code')) return;
      btn.addEventListener('click', function() {
        navigator.clipboard?.writeText(this.dataset.code).then(() => {
          this.textContent = '✓ 已複製';
          setTimeout(() => { this.textContent = this.dataset.code + ' 複製'; }, 1500);
        });
      });
    });
  }

  function bindDiscountForm(slot) {
    const form = slot.querySelector('[data-crb-discount-form]');
    const input = form?.querySelector('input[name="discount"]');
    const message = slot.querySelector('[data-crb-discount-message]');

    form?.addEventListener('submit', event => {
      event.preventDefault();
      const code = cleanDiscountCode(input?.value || '');
      if (!code) return;

      const submit = form.querySelector('button[type="submit"]');
      submit.disabled = true;
      submit.textContent = '套用中...';
      if (message) message.style.display = 'none';

      updateCartDiscount(code)
        .then(() => {
          if (input) input.value = '';
          if (message) {
            message.textContent = '優惠碼已套用，結帳時會自動帶入。';
            message.style.display = '';
          }
          scheduleSync();
        })
        .catch(e => {
          console.warn('[CRB] discount apply:', e);
          if (message) {
            message.textContent = '優惠碼套用失敗，請稍後再試。';
            message.style.display = '';
            message.style.color = '#b91c1c';
          }
        })
        .finally(() => {
          submit.disabled = false;
          submit.textContent = '套用';
        });
    });

    slot.querySelector('[data-crb-remove-code]')?.addEventListener('click', event => {
      const button = event.currentTarget;
      button.disabled = true;
      button.textContent = '移除中...';

      updateCartDiscount('')
        .then(cart => {
          updateBar(cart);
          scheduleSync();
        })
        .catch(e => {
          console.warn('[CRB] discount remove:', e);
          button.disabled = false;
          button.textContent = '移除';
        });
    });
  }

  function doSync() {
    const cartDrawer  = document.querySelector('cart-drawer');
    const isEmpty     = cartDrawer && cartDrawer.classList.contains('is-empty');
    const placeholder = document.getElementById('crb-placeholder');

    if (isEmpty) {
      if (placeholder) placeholder.style.display = 'none';
      return;
    }

    const header = document.querySelector('#CartDrawer .drawer__header');
    if (placeholder && header && placeholder.previousElementSibling !== header) {
      placeholder.remove();
    }
    injectBar();
    if (document.getElementById('crb-placeholder')) {
      document.getElementById('crb-placeholder').style.display = '';
    }

    const msg = document.getElementById('crb-message');
    if (msg) { msg.style.opacity = '0.4'; msg.innerHTML = '更新中...'; }
    fetch('/cart.js').then(r => r.json()).then(cart => {
      updateBar(cart);
      handleGifts(cart);
    }).catch(e => console.warn('[CRB]', e));
  }

  function updateBar(cart) {
    const total = getProgressTotal(cart);
    appliedDiscountCode = captureAppliedDiscountCode() || appliedDiscountCode;
    const appliedDiscountDetail = appliedDiscountCode ? getDiscountDetail(appliedDiscountCode) : null;
    appliedDiscountLabel = appliedDiscountCode ? captureAppliedDiscountLabel(appliedDiscountCode) : '';
    const requiredSubtotal = appliedDiscountDetail?.minSubtotal || 0;
    const discountNeedsMore = appliedDiscountCode && requiredSubtotal > 0 && total < requiredSubtotal;

    if (appliedDiscountCode && requiredSubtotal > 0 && total >= requiredSubtotal) {
      ensureDiscountApplied(appliedDiscountCode, total);
    }

    const fill = document.getElementById('crb-fill');
    const msg  = document.getElementById('crb-message');
    const slot = document.getElementById('crb-discount-slot');
    if (!fill || !msg) return;

    const tierEls = [...document.querySelectorAll('.crb-tier')];
    if (!tierEls.length) return;

    const tiers = tierEls.map(el => ({
      el,
      threshold:   parseInt(el.dataset.threshold),
      type:        el.dataset.type,
      code:        el.dataset.code,
      label:       el.dataset.label,
      msgPending:  el.dataset.msgP,
      msgAchieved: el.dataset.msgA,
    })).sort((a, b) => a.threshold - b.threshold);

    const freeShippingCovered = !!(
      appliedDiscountCode &&
      !discountNeedsMore &&
      isFreeShippingDetail(appliedDiscountDetail)
    );
    const freeShippingReserved = !!(
      appliedDiscountCode &&
      discountNeedsMore &&
      isFreeShippingDetail(appliedDiscountDetail)
    );
    const coveredShippingTier = freeShippingCovered
      ? tiers.find(t => t.type === 'free_shipping')
      : null;
    const tierIsDone = t => total >= t.threshold || (coveredShippingTier && t === coveredShippingTier);
    const progressTotal = coveredShippingTier ? Math.max(total, coveredShippingTier.threshold) : total;

    const MAX = tiers[tiers.length - 1].threshold;
    const fillMax = freeShippingReserved && requiredSubtotal > 0 ? requiredSubtotal : MAX;
    fill.style.width = Math.min(progressTotal / fillMax * 100, 100) + '%';
    tiers.forEach(t => t.el.classList.toggle('is-active', tierIsDone(t)));

    function fmt(c) { return 'NT$' + Math.round(c/100).toLocaleString('zh-TW'); }
    function interp(s, v) { return (s||'').replace(/\{(\w+)\}/g, (_,k) => v[k]!==undefined?v[k]:'{'+k+'}'); }

    const next     = tiers.find(t => !tierIsDone(t));
    const lastDone = [...tiers].reverse().find(t => tierIsDone(t));

    let newMsg = '';
    if (freeShippingReserved) {
      const rem = Math.max(requiredSubtotal - total, 0);
      const pending = `${appliedDiscountLabel || '免運優惠碼'} · 尚差 <strong>${fmt(rem)}</strong> 後會自動套用`;
      newMsg = `<span class="crb-message-pending">${pending}</span>`;
    } else if (!next) {
      newMsg = tiers.map(t =>
        `<span class="crb-message-achieved">✓ ${interp(t.msgAchieved, {discount_code: t.code})}</span>`
      ).join('');
    } else {
      const rem     = next.threshold - progressTotal;
      const pending = interp(next.msgPending, {
        amount: '<strong>' + fmt(rem) + '</strong>',
        reward: '<strong>' + next.label + '</strong>',
        discount_code: next.code,
      });
      newMsg = lastDone
        ? `<span class="crb-message-achieved">✓ ${interp(lastDone.msgAchieved, {discount_code:lastDone.code})}</span><span class="crb-message-pending">${pending}</span>`
        : `<span class="crb-message-pending">${pending}</span>`;
    }

    if (msg.innerHTML !== newMsg) {
      msg.style.opacity = '0';
      setTimeout(() => { msg.innerHTML = newMsg; msg.style.opacity = ''; }, 120);
    }

    if (slot) {
      const banners = [];
      if (appliedDiscountCode) {
        const remainingForDiscount = Math.max(requiredSubtotal - total, 0);
        const discountDetailText = discountNeedsMore
          ? `${appliedDiscountLabel ? appliedDiscountLabel + ' · ' : ''}${remainingForDiscount > 0 ? '尚差 ' + formatMoney(remainingForDiscount) : '滿額'} 後會自動套用`
          : appliedDiscountLabel;
        const discountLabel = discountNeedsMore ? '優惠碼已保留' : '已套用優惠碼';
        banners.push(discountBannerHTML(appliedDiscountCode, discountLabel, discountDetailText, true, false));
      }

      const earned = tiers.filter(t => t.type==='discount' && t.code && total>=t.threshold);
      if (earned.length) {
        const t   = earned[earned.length-1];
        const dot = t.el.querySelector('.crb-tier-dot')?.textContent || '';
        if (!appliedDiscountCode || appliedDiscountCode.toLowerCase() !== t.code.toLowerCase()) {
          banners.push(discountBannerHTML(t.code, `${escapeHTML(dot)} 已解鎖折扣碼`, '', false));
        }
      }

      if (appliedDiscountCode) {
        slot.innerHTML = banners.join('');
        bindDiscountCopyButtons(slot);
        bindDiscountForm(slot);
      } else if (banners.length) {
        slot.innerHTML = banners.join('') + discountFormHTML();
        bindDiscountCopyButtons(slot);
        bindDiscountForm(slot);
      } else {
        slot.innerHTML = discountFormHTML();
        bindDiscountForm(slot);
      }
    }
  }

  let giftLock = false;
  async function handleGifts(cart) {
    if (giftLock) return;
    const cfg = window.crbConfig;
    if (!cfg) return;
    const giftTiers = (cfg.tiers||[]).filter(t => t.type==='free_gift' && t.gift && /^\d+$/.test(String(t.gift).trim()));
    if (!giftTiers.length) return;

    const total = getProgressTotal(cart);
    for (const t of giftTiers) {
      const has  = cart.items.some(i => String(i.variant_id)===String(t.gift));
      const qual = total >= t.threshold;

      if (qual && !has) {
        giftLock = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({id: parseInt(t.gift), quantity: 1})
          });
          if (res.ok) {
            await reRenderCart();
          } else {
            console.warn('[CRB] gift add failed:', res.status);
          }
        } catch(e) {
          console.warn('[CRB] gift add:', e);
        }
        giftLock = false;

      } else if (!qual && has) {
        giftLock = true;
        const item = cart.items.find(i => String(i.variant_id)===String(t.gift));
        if (item) {
          try {
            await fetch('/cart/change.js', {
              method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({id: item.key, quantity: 0})
            });
            await reRenderCart();
          } catch(e) {
            console.warn('[CRB] gift remove:', e);
          }
        }
        giftLock = false;
      }
    }
  }

  function setupListeners() {
    if (initialized) return;
    initialized = true;

    document.addEventListener('cart:refresh', scheduleSync);

    const drawerInner = document.querySelector('#CartDrawer .drawer__inner, #CartDrawer [role="dialog"]');
    if (drawerInner) {
      new MutationObserver(mutations => {
        let needsInject = false;
        mutations.forEach(m => {
          m.removedNodes.forEach(node => {
            if (node.nodeType === 1 && (
              node.classList?.contains('drawer__header') ||
              node.id === 'crb-placeholder'
            )) {
              needsInject = true;
            }
          });
        });
        if (needsInject) {
          queueMicrotask(() => { injectBar(); scheduleSync(); });
        } else {
          scheduleSync();
        }
      }).observe(drawerInner, { childList: true });
    }

    const cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      new MutationObserver(() => {
        scheduleSync();
      }).observe(cartDrawerEl, { attributes: true });
    }

    const subtotalEl = document.querySelector('.totals__total-value');
    if (subtotalEl) {
      new MutationObserver(scheduleSync)
        .observe(subtotalEl, { childList: true, subtree: true, characterData: true });
    }

    // 每 300ms 檢查進度條是否存在
    setInterval(() => {
      const cartDrawer = document.querySelector('cart-drawer');
      const isEmpty = cartDrawer && cartDrawer.classList.contains('is-empty');
      if (isEmpty) return;
      const header = document.querySelector('#CartDrawer .drawer__header');
      if (!header) return;
      const bar = document.getElementById('cart-rewards-bar');
      if (!bar) { injectBar(); scheduleSync(); }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupListeners);
  } else {
    setupListeners();
  }

})();
